import { createTheme } from '@mui/material/styles';

const lightPalette = {
  primary: {
    main: '#234C7C',
    contrastText: '#fff',
  },
  secondary: {
    main: '#6CA0DC',
    contrastText: '#fff',
  },
  background: {
    default: '#F4F6FA',
    paper: '#fff',
  },
  text: {
    primary: '#22223B',
    secondary: '#6B7280',
  },
  error: { main: '#F44336' },
  warning: { main: '#FF9800' },
  info: { main: '#2196F3' },
  success: { main: '#4CAF50' },
  divider: '#E0E0E0',
};

const darkPalette = {
  primary: {
    main: '#234C7C',
    contrastText: '#fff',
  },
  secondary: {
    main: '#6CA0DC',
    contrastText: '#fff',
  },
  background: {
    default: '#181A20',
    paper: '#23272E',
  },
  text: {
    primary: '#F4F6FA',
    secondary: '#B0B3B8',
  },
  error: { main: '#F44336' },
  warning: { main: '#FF9800' },
  info: { main: '#2196F3' },
  success: { main: '#4CAF50' },
  divider: '#23272E',
};

const themeBase = {
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: 'Inter, Roboto, Arial, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none' as const, fontWeight: 600 },
  },
};

export const getTheme = (mode: 'light' | 'dark') =>
  createTheme({
    ...themeBase,
    palette: {
      mode,
      ...(mode === 'light' ? lightPalette : darkPalette),
    },
  });